import { render, staticRenderFns } from "./BaseViewLayout.vue?vue&type=template&id=11516d64&scoped=true&"
import script from "./BaseViewLayout.vue?vue&type=script&lang=js&"
export * from "./BaseViewLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseViewLayout.vue?vue&type=style&index=0&id=11516d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11516d64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
